import { parseInt, isObject as _isObject } from 'lodash';
import moment from 'moment';

const currentMonth = moment().get('month') + 1;
const currentYear = moment().get('year').toString().substr(2, 2);
var acceptedCreditCards = {
  visa: /^4[0-9]{12}(?:[0-9]{3})?$/,
  mastercard:
    /^5[1-5][0-9]{14}$|^2(?:2(?:2[1-9]|[3-9][0-9])|[3-6][0-9][0-9]|7(?:[01][0-9]|20))[0-9]{12}$/,
  amex: /^3[47][0-9]{13}$/,
};

function cardIsValid(cardNumber) {
  // remove all non digit characters
  var value = cardNumber.replace(/\D/g, '');
  var sum = 0;
  var shouldDouble = false;
  // loop through values starting at the rightmost side
  for (var i = value.length - 1; i >= 0; i--) {
    var digit = parseInt(value.charAt(i));

    if (shouldDouble) {
      if ((digit *= 2) > 9) {
        digit -= 9;
      }
    }

    sum += digit;
    shouldDouble = !shouldDouble;
  }
  return sum % 10 == 0;
}
function cardIsSupported(cardNumber) {
  // remove all non digit characters
  var value = cardNumber.replace(/\D/g, '');
  var accepted = false;

  // loop through the keys (visa, mastercard, amex, etc.)
  Object.keys(acceptedCreditCards).forEach(function (key) {
    var regex = acceptedCreditCards[key];
    if (regex.test(value)) {
      accepted = true;
    }
  });

  return accepted;
}

const validateCardNo = (text = '') => {
  return cardIsSupported(text) && cardIsValid(text);
};
const validateName = (text = '') => {
  return text.length;
};

const validateCCV = (text = '') => {
  return text.length === 3 || text.length === 4;
};

const isDateUpComming = ({ year, month }) => {
  if (year < +currentYear) {
    return false;
  }
  if (+currentYear === year && month < currentMonth) {
    return false;
  }
  return true;
};

const ValidateExpirationData = (text = '') => {
  let isValid = typeof text === 'string' && text[2] === '/' && text.length === 5;
  const monthPart = isValid && parseInt(text.substr(0, 2));
  const isValidMonth = isValid && monthPart <= 12 && monthPart > 0;
  isValid = isValid && isValidMonth;
  if (text.length === 5 && isValidMonth) {
    const [month, year] = text.split('/');
    return isDateUpComming({ month: +month, year: +year });
  }
  return isValid;
};

const isValidPaymentMethodCard = card => {
  return _isObject(card) && card.cardName && card.lastFourDigits && card.expiry && card.nameOnCard;
};

export {
  validateCCV,
  ValidateExpirationData,
  validateName,
  validateCardNo,
  isValidPaymentMethodCard,
};
